<nz-card nzTitle="Info codes">
  <nz-skeleton [nzActive]="true" [nzLoading]="(loading$ | async) ?? false">
    <em-info-codes-table
      [data]="(infoCodes$ | async) ?? []"
      [loading]="(loading$ | async) ?? false"
      [errorMsg]="(error$ | async) ?? undefined"
      (longTextClicked)="displayLongText($event)"
    ></em-info-codes-table>
  </nz-skeleton>
</nz-card>

<ng-template #longTextTemplate let-longText>
  <pre>{{ longText }}</pre>
</ng-template>
